import { render, staticRenderFns } from "./RefuseDrawer.vue?vue&type=template&id=582dd196&scoped=true"
import script from "./RefuseDrawer.vue?vue&type=script&lang=js"
export * from "./RefuseDrawer.vue?vue&type=script&lang=js"
import style0 from "./RefuseDrawer.vue?vue&type=style&index=0&id=582dd196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582dd196",
  null
  
)

export default component.exports